import { render, staticRenderFns } from "./button-drip.vue?vue&type=template&id=3bb13996&lang=pug&"
import script from "./button-drip.vue?vue&type=script&lang=js&"
export * from "./button-drip.vue?vue&type=script&lang=js&"
import style0 from "./button-drip.vue?vue&type=style&index=0&module=true&lang=stylus&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports